import {Injectable} from '@angular/core';
import {Observable, Subject} from 'rxjs';

@Injectable({providedIn: 'root'})
export class DrawingEditorToolsService {
  private _collapseGroups$: Subject<void> = new Subject();

  get onCollapseGroups$(): Observable<void> {
    return this._collapseGroups$.asObservable();
  }

  collapseGroups(): void {
    this._collapseGroups$.next();
  }
}
